export default __webpack_public_path__ + "static/media/15.aebc216d.jpg";